import { useUser } from 'context/UserContext';
import React from 'react';
import CreateTeam from './CreateTeam';
import Team from './Team';

const TeamRouter = () => {
  const user = useUser();
  if (user?.team.name) {
    return <Team />;
  } else {
    return <CreateTeam />;
  }
};

export default TeamRouter;
